export class ServiceDataManager {

    constructor(model, entityService) {

        if (!model)
            throw new Error('[ServiceDataManager]: "model" is required');
        if (!entityService)
            throw new Error('[ServiceDataManager]: "entityService" is required');

        this.model = model;
        this.entityService = entityService;

    };

    getModel() {

        return this.model;

    };

    getEntityService() {

        return this.entityService;

    };

    async queryData(query) {

        const result = await this.getEntityService().queryData(query);
        return this.model?.deserializeDatasetFromWire
            ? this.model.deserializeDatasetFromWire(result)
            : result;

    };

    async createData(data) {

        if (!data)
            throw new Error('ServiceDataManager error: Can\'t create remote data. Data are empty.');

        const serializedData = this.model?.serializeObjectForWire
            ? this.model.serializeObjectForWire(data)
            : data;

        return this.getEntityService().createData(serializedData);

    };

    async readData(data) {

        const id = this.resolveDataId(data, 'read');
        const result = await this.getEntityService().readData(id);

        return this.model?.deserializeObjectFromWire
            ? this.model.deserializeObjectFromWire(result)
            : result;

    };

    async updateData(data) {

        if (!data)
            throw new Error('ServiceDataManager error: Can\'t update remote data. Data are empty.');

        const id = this.resolveDataId(data, 'update');
        const serializedData = this.model?.serializeObjectForWire
            ? this.model.serializeObjectForWire(data)
            : data;

        const result = await this.getEntityService().updateData(id, serializedData);
        return this.model?.deserializeObjectFromWire
            ? this.model.deserializeObjectFromWire(result)
            : result;

    };

    async deleteData(data) {

        const id = this.resolveDataId(data, 'delete');
        return this.getEntityService().deleteData(id);

    };

    resolveDataId(data, operation) {

        if (!data)
            throw new Error(`ServiceDataManager error: Can't ${operation} remote data. Data are empty.`);

        const id = (data && typeof data === 'object')
            ? (data.id ?? this.model?.getPrimaryKey?.(data) ?? null)
            : data;
        if (!id)
            throw new Error(`ServiceDataManager error: Can't ${operation} remote data. ID is missing.`);

        return id;

    };

}
